import { VideoFragmentFragment } from '../../__generated__/graphql';
import Video from '../../components/Video';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

interface VideoContentBlockProps {
  pageType: 'page' | 'post';
}

const VideoContentBlock: ContentBlock<VideoFragmentFragment, VideoContentBlockProps> = ({ fragment, pageType }) => {
  const contentBlockProps = fragment.video;

  if (!contentBlockProps?.url) {
    return null;
  }

  if (pageType === 'post') {
    return (
      <section id={contentBlockProps.sectionId ?? undefined}>
        <Video src={contentBlockProps.url} />
      </section>
    );
  }

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
    >
      <Video src={contentBlockProps.url} />
    </Section>
  );
};

export default VideoContentBlock;
